import { render, staticRenderFns } from "./ImportModalPoint.vue?vue&type=template&id=271b59de&scoped=true"
import script from "./ImportModalPoint.vue?vue&type=script&lang=js"
export * from "./ImportModalPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b59de",
  null
  
)

export default component.exports